var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgRejectsSummary = function SvgRejectsSummary(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.6 24.6H37.0998L14.2998 144H128.8L150.6 24.6Z",
    fill: "#E6E6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.2 131.7H16.7002L17.9002 126.2H132L131.2 131.7Z",
    fill: "#9FA4D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.8 126.7H11.5C10.7 126.7 10 126 10 125.2C10 124.4 10.7 123.7 11.5 123.7H138.8C139.6 123.7 140.3 124.4 140.3 125.2C140.3 126 139.7 126.7 138.8 126.7Z",
    fill: "#313E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.5 124.6H46.6998C45.0998 124.6 43.8998 123.4 43.7998 121.8L40.7998 33H91.5998C99.7998 33 106.4 39.6 106.4 47.8L109.4 121.6C109.5 123.2 108.2 124.6 106.5 124.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.5 126.1H46.7002C44.3002 126.1 42.4002 124.2 42.3002 121.9L39.2002 31.5H91.5002C100.5 31.5 107.8 38.8 107.8 47.8L110.8 121.5C110.8 122.7 110.4 123.8 109.6 124.7C108.9 125.6 107.7 126.1 106.5 126.1ZM42.4002 34.5L45.4002 121.8C45.4002 122.5 46.0002 123.1 46.8002 123.1H106.6C107 123.1 107.3 122.9 107.6 122.7C107.9 122.4 108 122.1 108 121.7L105 47.9C105 40.5 99.0002 34.5 91.6002 34.5H42.4002Z",
    fill: "#323E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8 62.3H55V65.3H91.8V62.3Z",
    fill: "#323E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8 72.6H55V75.6H91.8V72.6Z",
    fill: "#323E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8 82.8H55V85.8H91.8V82.8Z",
    fill: "#323E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9002 107.9H29.1002C27.5002 107.9 26.2002 106.6 26.2002 105V20.4C26.2002 18.8 27.5002 17.5 29.1002 17.5H77.0002C85.2002 17.5 91.8002 24.1 91.8002 32.3V105C91.8002 106.6 90.5002 107.9 88.9002 107.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9002 109.4H29.1002C26.7002 109.4 24.7002 107.4 24.7002 105V20.4C24.7002 18 26.7002 16 29.1002 16H77.0002C86.0002 16 93.3002 23.3 93.3002 32.3V105C93.3002 107.4 91.3002 109.4 88.9002 109.4ZM29.1002 19C28.3002 19 27.7002 19.6 27.7002 20.4V105C27.7002 105.8 28.3002 106.4 29.1002 106.4H88.9002C89.7002 106.4 90.3002 105.8 90.3002 105V32.3C90.3002 25 84.3002 19 76.9002 19H29.1002Z",
    fill: "#323E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8004 33.4H76.9004V17.5C76.9004 17.5 92.4004 19.5 91.8004 33.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8004 34.9H76.9004C76.1004 34.9 75.4004 34.2 75.4004 33.4V17.5C75.4004 17.1 75.6004 16.7 75.9004 16.4C76.2004 16.1 76.7004 16 77.1004 16C77.3004 16 93.9004 18.4 93.3004 33.4C93.2004 34.2 92.6004 34.9 91.8004 34.9ZM78.4004 31.9H90.3004C90.1004 27.4 87.9004 24 83.8004 21.6C81.8004 20.4 79.8004 19.8 78.4004 19.4V31.9Z",
    fill: "#323E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0998 46.8H40.2998V49.8H77.0998V46.8Z",
    fill: "#323E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0998 57.1H40.2998V60.1H77.0998V57.1Z",
    fill: "#323E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0998 67.3H40.2998V70.3H77.0998V67.3Z",
    fill: "#323E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0998 83.2H41.2998V92.7H75.0998V83.2Z",
    fill: "#DBC553"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4998 94.2H39.7998V81.7H76.5998V94.2H76.4998ZM42.7998 91.2H73.5998V84.7H42.7998V91.2Z",
    fill: "#323E48"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M92.6004 114.6C109.279 114.6 122.8 101.079 122.8 84.4C122.8 67.721 109.279 54.2 92.6004 54.2C75.9214 54.2 62.4004 67.721 62.4004 84.4C62.4004 101.079 75.9214 114.6 92.6004 114.6Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M92.5004 116.3C75.0004 116.3 60.9004 102.1 60.9004 84.7C60.9004 67.3 75.1004 53 92.5004 53C109.9 53 124.1 67.2 124.1 84.6C124.1 102 110 116.3 92.5004 116.3ZM92.5004 56C76.7004 56 63.9004 68.9 63.9004 84.6C63.9004 100.3 76.8004 113.2 92.5004 113.2C108.3 113.2 121.1 100.3 121.1 84.6C121.1 68.9 108.3 56 92.5004 56Z",
    fill: "#323E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.6 125.7C132.2 125.7 131.8 125.6 131.5 125.3L113.9 107.7C113.3 107.1 113.3 106.2 113.9 105.6C114.5 105 115.4 105 116 105.6L133.6 123.2C134.2 123.8 134.2 124.7 133.6 125.3C133.4 125.5 133 125.7 132.6 125.7Z",
    fill: "#323E48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 94.4L98.0998 85.5L106.7 76.9L101.4 71.6L92.7998 80.2L83.8998 71.3L78.5998 76.6L87.4998 85.5L78.2998 94.7L83.5998 100L92.7998 90.8L101.7 99.7L107 94.4Z",
    fill: "#E3A09B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6002 102.2L76.2002 94.8L85.4002 85.6L76.5002 76.7L83.9002 69.3L92.8002 78.2L101.4 69.6L108.8 77L100.2 85.6L109.1 94.5L101.7 101.9L92.8002 93L83.6002 102.2ZM80.4002 94.7L83.6002 97.9L92.8002 88.7L101.7 97.6L104.9 94.4L96.0002 85.5L104.6 76.9L101.4 73.7L92.8002 82.3L83.9002 73.4L80.7002 76.6L89.6002 85.5L80.4002 94.7Z",
    fill: "#323E48"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140.6,
    height: 128,
    fill: "white",
    transform: "translate(10 16)"
  })))));
};
export { SvgRejectsSummary as ReactComponent };
export default __webpack_public_path__ + "static/media/rejects-summary.25ef8397.svg";